export default {
  mobileWidth: 560,
};
